import {addressKnown, intendedUse, propertyValue, purchasePrice, spendAmount} from "./property";
import {monthlyPayment} from "./existing";
import {FaExchangeAlt, FaHome, FaSign, FaTruckMoving, FaUmbrellaBeach, FaUser, FaUserFriends} from "react-icons/fa";
import {counties} from "../counties";
export function calc(props) {
    const questions = [];

    if (props.mortgage.mortgageType === 'PURCHASE') {
        if (props.mortgage.property.addressKnown) {
            const q = purchasePrice(props)
            delete (q.hides)
            questions.push(q)
        } else {
            const q = spendAmount(props)
            delete (q.hides)
            questions.push(q)
        }
    } else {
        const q = propertyValue(props)
        delete (q.hides)
        questions.push(q)

    }
    questions.push(loanRequired(props))
    questions.push(loanTerm(props))
    if (props.mortgage.mortgageType === 'REFINANCE') {
        const r = monthlyPayment(props)
        delete (r.hides)
        questions.push(r)
    }
    questions.push(rate(props))

    return {
        name: `calc`,
        title: 'Calculate your monthly payments',
        link: `setup`,
        props: props,
        questions: questions,
        applicant: false
    }
}
export function rate(props) {

    return {
        label: props.mortgage.mortgageType === 'REFINANCE' ? 'New Rate' : 'Rate',
        name: 'rateId',
        model: 'requirement',
        answer: {
            type: 'choice',
            choices: [],
            // type: 'float',
            // validation: {
            //     min: {value: 0.01, message: "The minimum rate is 0.01%"},
            //     max: {value: 25, message: "The maximum rate is 25%"}
            // },
            // step: 0.01
        },
        //suffix:'%'
    }
}

export default function setup(props) {
    const questions = [];
    questions.push(mortgageType(props))
    questions.push({
        ...intendedUse(props), hides: {
            mortgageType: (v) => {
                return v !== "PURCHASE"
            }
        }
    })
    questions.push(twoApplicants(props))
    questions.push(helpToBuyScheme(props))
    questions.push(firstHomeScheme(props))
    questions.push(loanRequired(props))
    questions.push(loanTerm(props))

    return {
        name: `setup`,
        title: 'Setup your mortgage',
        link: `setup`,
        props: props,
        questions: questions,
        applicant: false
    }
}
export function loanRequired(props) {
    return {
        label: 'Loan required',
        name: 'loanRequired',
        text: 'How much do you need to borrow?',
        model: 'requirement',
        answer: {
            type: 'euro',
            validation: {
                min: {value: 50000, message: "The minimum value here is €50,000"},
                max: {value: 1000000, message: "The maximum value here is €1,000,000"}
            },
            step: 1000
        }

    }
}
export function helpToBuyScheme(props) {
    return {
        label: 'Help to buy scheme',
        name: 'helpToBuyScheme',
        text: 'Are you availing of the Help to Buy Scheme?',
        model: 'requirement',
        answer: {
            type: 'choice',
            choices: [
                {
                    value: false,
                    text: 'Yes',
                },
                {
                    value: true,
                    text: 'No',
                }
            ]
        },
        hides: {
            mortgageType: (v)=> v!== "PURCHASE"
        }

    }
}
export function firstHomeScheme(props) {
    return {
        label: 'First home scheme',
        name: 'firstHomeScheme',
        text: 'Are you availing of the First Home Scheme?',
        model: 'requirement',
        answer: {
            type: 'choice',
            choices: [
                {
                    value: true,
                    text: 'Yes',
                },
                {
                    value: false,
                    text: 'No',
                }
            ]
        },
        hides: {
        mortgageType: (v)=> v!== "PURCHASE"
    }
    }
}

export function firstHomeSchemeCouncil(props) {
    return {
        label: 'County Council',
        name: 'firstHomeSchemeCouncil',
        text: 'In which council will you buy a property?',
        model: 'requirement',
        answer: {
            type: 'choice',
            choices: counties.map(county=>{
                return {
                    value: county.name,
                    text: county.text
                }
            })
        },
        hides: {
            mortgageType: (v)=> v !== "PURCHASE",
            firstHomeScheme: (v)=> !v
        }
    }
}
export function firstHomeSchemeType(props) {
    return {
        label: 'Property Type',
        name: 'firstHomeSchemeType',
        text: 'What type of property are you buying?',
        model: 'requirement',
        answer: {
            type: 'choice',
            choices: [
                {
                    value: "APARTMENT",
                    text: "Apartment"
                },
                {
                    value: "HOUSE",
                    text: "House"
                }
            ]
        },
        hides: {
            mortgageType: (v)=> v!== "PURCHASE",
            firstHomeScheme: (v)=> !v,
            firstHomeSchemeCouncil:(v)=> {
                if (v){
                    let county = counties.find(c=>c.name===v)
                    return !county?.apartment
                }
                return true
            }
        }
    }
}

export function twoApplicants(props) {
    return {
        label: 'Number of applicants',
        name: 'twoApplicants',
        text: 'How many people will apply for the mortgage?',
        model: 'mortgage',
        answer: {
            type: 'choice',
            choices: [
                {
                    value: false,
                    text: 'One',
                    icon: <FaUser/>

                },
                {
                    value: true,
                    text: 'Two',
                    icon: <FaUserFriends/>
                }
            ]
        }

    }
}
export function loanTerm(props) {
    return {
        text: 'Over how many years would you like to repay the loan?',
        label: 'Term of loan',
        name: 'loanTerm',
        model: 'requirement',
        answer: {
            type: 'int',
            validation: {
                min: {value: 2, message: "The minimum term is 2 years"},
                max: {value: 35, message: "The maximum term is 35 years"}
            },
            suffix: ' years',
            step: 1
        }
    }
}
export function mortgagePurpose(props) {
    return {
        label: "Mortgage Type",
        text: "What is the purpose of this mortgage?",
        name: "mortgageType",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "First-time buyer",
                    value: "FIRSTTIME",
                    icon: <FaHome size={23}/>
                },
                {
                    text: "Buy-to-let",
                    value: "BUYTOLET",
                    icon: <FaSign/>
                },
                {
                    text: "Moving home",
                    value: "MOVING",
                    icon: <FaTruckMoving/>
                },
                {
                    text: "2nd home",
                    value: "HOLIDAYHOME",
                    icon: <FaUmbrellaBeach/>
                },
                {
                    text: "Switch mortgage",
                    value: "REFINANCE",
                    icon: <FaExchangeAlt/>

                }
            ]
        },
        model: "mortgage"
    }
}
export function mortgageType(props) {
    return {
        label: "Mortgage Type",
        text: "What is the purpose of this mortgage?",
        name: "mortgageType",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Purchase Home",
                    value: "PURCHASE",
                    icon: <FaHome size={23}/>
                },
                {
                    text: "Switch mortgage",
                    value: "REFINANCE",
                    icon: <FaExchangeAlt/>

                }
            ]
        },
        model: "mortgage"
    }
}
export function firstTimeBuyer(props) {
    return {
        label: "Mortgage Type",
        text: "What is the purpose of this mortgage?",
        name: "mortgageType",
        model: 'requirement',
        answer: {
            type: 'choice',
            choices: [
                {
                    text: 'Yes',
                    value: true
                },
                {
                    text: 'No',
                    value: false
                }
            ]
        }
    }
}
export function depositGifts(props) {
    return {
        label: 'Total Gifts',
        name: 'depositGifts',
        text: 'What is value of all gifts you\'ll receive to help with the deposit?',
        model: 'requirement',
        answer: {
            type: 'euro',
            validation: {
                min: {value: 1000, message: "The minimum value here is €1,000"},
                max: {value: 1000000, message: "The maximum value here is €1,000,000"}
            },
            step: 1000
        }

    }
}
export function depositSavings(props) {
    return {
        label: 'Total Own Funds',
        name: 'depositSavings',
        text: 'How much of your own funds will make up the deposit?',
        model: 'requirement',
        answer: {
            type: 'euro',
            validation: {
                min: {value: 1000, message: "The minimum value here is €1,000"},
                max: {value: 1000000, message: "The maximum value here is €1,000,000"}
            },
            step: 1000
        }

    }
}
export {addressKnown, purchasePrice, spendAmount, propertyValue, monthlyPayment}